<template>
    <AppContainer id="add-credit-card-container">
        <div class="row">
            <div class="col-12">
                <CardAcceptedBrands />
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12 col-lg-6 form-group">
                <label for="add_credit_card_name" class="form-label">Nome no cartão</label>
                <input type="text" class="form-control" id="add_credit_card_name" v-model.trim="$v.holder_name.$model"
                    placeholder="João Silva">
            </div>
            <div class="col-12 col-lg-6 form-group">
                <label for="add_credit_card_number" class="form-label">Número do cartão</label>
                <input type="text" class="form-control" v-maska :data-maska="creditCardNumberMask"
                    id="add_credit_card_number" v-model.trim="$v.number.$model" placeholder="0000 0000 0000 0000">
            </div>
            <div class="col-6 form-group">
                <label for="add_credit_card_expiration_date" class="form-label">Validade do cartão</label>
                <input type="text" class="form-control" id="add_credit_card_expiration_date"
                    v-model.trim="$v.expiration_date.$model" v-maska :data-maska="creditCardExpirationDate"
                    placeholder="12/29">
            </div>
            <div class="col-6 form-group">
                <label for="add_credit_card_cvv" class="form-label">CVV</label>
                <input type="text" class="form-control" v-maska :data-maska="numberMask" id="add_credit_card_cvv"
                    v-model.trim="$v.cvv.$model" placeholder="123">
            </div>
            <div class="col-12 form-group">
                <label for="add_credit_card_document" class="form-label">CPF</label>
                <input type="text" class="form-control" v-maska :data-maska="cpfMask" id="add_credit_card_document"
                    v-model.trim="$v.document_number.$model" placeholder="999.999.999-99">
            </div>
            <hr>
            <h2 class="fw-bold">Endereço</h2>
            <AddressComponent @onChange="addressChanged" />
            <p>
                <small>
                    Nenhuma cobrança será feita antes de uma recarga ser realizada. Estamos adicionando um método de
                    pagamento para facilitar o processo.
                </small>
            </p>
        </div>
        <SubmitBtn id="card-submit-btn" :loading="submitting" @click.prevent="handleCreateCard" title="Concluir"
            class="w-100" />

    </AppContainer>
</template>
<script lang="ts" setup>
import AddressComponent from '@/components/AddressComponent.vue';
import AppContainer from '@/components/AppContainer.vue';
import CardAcceptedBrands from '@/components/CardAcceptedBrands.vue';
import useOffCanvas from '@/components/Offcanvas/useOffCanvas';
import useCards from '@/composables/useCards';
import useForm from '@/composables/useForm';
import usePayment from '@/composables/usePayment';
import { IAddressResponse } from '@/interfaces';
import paths from '@/router/paths';
import { creditCardValidations } from '@/utils/form_validations';
import { cpfMask, creditCardExpirationDate, creditCardNumberMask, numberMask } from '@/utils/masks';
import useVuelidate from '@vuelidate/core';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

const { createCard, submitting } = useCards()
const { user_document_number } = usePayment()
const { canvasBackPressed, closeCanvas} = useOffCanvas()
const { invalidForm } = useForm()
const route = useRoute()

const addressResponse = ref<IAddressResponse>({
    address: {
        street: '',
        number: '',
        zip_code: '',
        city: '',
        state: '',
        country: ''
    },
    form: {},
})
const holder_name = ref("")
const number = ref("")
const expiration_date = ref("")
const cvv = ref("")
const document_number = ref(user_document_number)

const $v = useVuelidate(
    creditCardValidations(),
    {
        holder_name,
        number,
        expiration_date,
        cvv,
        document_number,
    }
)

const cardForm = computed(() => {
    let exp_month = ''
    let exp_year = ''
    if (expiration_date.value) {
        exp_month = expiration_date.value.split('/')[0]
        exp_year = expiration_date.value.split('/')[1]
    }

    return {
        holder_name: holder_name.value,
        number: number.value,
        cvv: cvv.value,
        exp_month,
        exp_year,
        document_number: document_number.value
    }
})

const addressChanged = (response: IAddressResponse) => {
    addressResponse.value = response
}

const handleCreateCard = () => {
    $v.value.$touch()
    if (invalidForm($v.value, addressResponse.value?.form)) {
        return
    }
    createCard(addressResponse.value.address, cardForm.value, () => {
        console.log('cartão criado')
        handleCanvasNavigation()
    })
}
const handleCanvasNavigation = () => {
if(route.path == paths.more.root) {
  canvasBackPressed()
} else {
  closeCanvas()
}
}
</script>